import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Component, Inject, OnInit} from '@angular/core';
import {FileManagerService} from '../../main/file-manager/file-manager.service';
import {ProgressBarMode} from '@angular/material/progress-bar';



@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './save-file-dialog.component.html',
    styleUrls: ['./save-file-dialog.component.scss']
})

export class SaveFileDialogComponent implements OnInit {
    completeProgress = 0;
    totalProcessCount = 0;
    currentProcessIndex = 0;
    currentOverwriteMethod = 'None';
    statusMessage: string;
    showOverwrite = false;
    processingFileName: string;
    progressMode: ProgressBarMode = 'determinate';
    showConfirm = false;
    showProgress = false;
    currentConvertMode = 'TBD';
    showOfferConvert = false;
    private _convertIndex = -1;

    constructor(
        private dialogRef: MatDialogRef<SaveFileDialogComponent>,
        public _fileManagerService: FileManagerService,
        @Inject(MAT_DIALOG_DATA) public data: SaveFileModel
    ) {

    }

    ngOnInit(): void {
        this.processingFileName = this.data.fileList[0].fullPath;
        this.showConfirm = this.data.mustConfirm;
        this.totalProcessCount = this.data.fileList.length;
        if (this.data.overwriteByDefault){
            this.currentOverwriteMethod = 'All';
        }
        if (!this.showConfirm) {
            this.uploadFiles(0).then((processResult) => {
                    if (processResult) {
                        this.dialogRef.close(true);
                    }
                }
            );
        }
    }

    async getBase64File(file: File): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (event: any): void => {
                resolve((event.target.result as string).split(',')[1]);
            };
        });
    }

    async uploadFiles(startIndex = 0): Promise<any> {
        this.showProgress = true;
        this.progressMode = 'determinate';
        this.totalProcessCount = this.data.fileList.length;
        for (let _i = startIndex; _i < this.data.fileList.length; _i++) {
            const file = this.data.fileList[_i];
            this.completeProgress = Math.round((_i + 1) * 100 / this.totalProcessCount);
            this.currentProcessIndex = _i;
            this.processingFileName = file.fullPath;
            let base64file = await this.getBase64File(file);
            let fullFilePath;
            if (this.data.folderPath === '/') {
                fullFilePath = file.fullPath;
            }
            else {
                fullFilePath = this.data.folderPath + '/' + file.fullPath;
            }


            let createSuccess = false;
            // Check Wave file format
            const fileExtension = fullFilePath.substr(fullFilePath.length - 3);
            if (fileExtension.toUpperCase() === 'MP3'
                || (fileExtension.toUpperCase() === 'WAV'  && !this._fileManagerService.isulaw(atob(base64file))))
            {
                if ((this.currentConvertMode === 'TBD'
                    || this.currentConvertMode === 'NoCurrent'
                    || this.currentConvertMode === 'YesCurrent')
                    && this._convertIndex !== this.currentProcessIndex)
                {
                    this.showOfferConvert = true;
                    return false;
                }
                if ((this.currentConvertMode === 'YesCurrent' && this._convertIndex === this.currentProcessIndex) || this.currentConvertMode === 'YesAll')
                {
                    const convertedFile = await this._fileManagerService.convertFile(fileExtension, base64file);
                    base64file = convertedFile.ttsFile.file;
                    fullFilePath = fullFilePath.replace(fullFilePath.substr(fullFilePath.length - 4), '.wav');
                    this.processingFileName = fullFilePath;
                }
            }
            let curOverWrite = false;
            switch (this.currentOverwriteMethod)
            {
                case 'None':
                {
                    curOverWrite = false;
                    break;
                }
                case 'All':
                {
                    curOverWrite = true;
                    break;
                }
                case 'Current':
                {
                    curOverWrite = true;
                    this.currentOverwriteMethod = 'None';
                    break;
                }
            }
            await this._fileManagerService.uploadFile(fullFilePath, base64file, curOverWrite).then( () => {createSuccess = true; })
                .catch((error) => {
                    const errorType = error.fileErrorType;
                    if (errorType === 'AACFileInfo')
                    {
                        console.log(error);
                        this.dialogRef.close(error);
                    }
                    else {
                    this.statusMessage = error.aac_error;
                    if (error.error.error_description === 'FileExists') {
                            this.showOverwrite = true;
                            this.progressMode = 'indeterminate';
                    } else {
                            this.dialogRef.close(error);
                    }
                    }
                });
            if (!createSuccess){
                return false;
            }
        }
        return true;
    }

    cancelProcess(): void {
        this.dialogRef.close(false);
    }

    skipFile(): void {
        this.showOverwrite = false;
        this.uploadFiles(this.currentProcessIndex + 1).then( (processResult) => {
            if (processResult)
            {
                this.dialogRef.close(true);
            }
        });
    }
    convertFile(ConvertMode: string): void {
        this.showOfferConvert = false;
        this.currentConvertMode = ConvertMode;
        this._convertIndex = this.currentProcessIndex;
        this.uploadFiles( this.currentProcessIndex).then( (processResult) => {
            if (processResult)
            {
                this.dialogRef.close(true);
            }
        });
    }
    overwriteFile(OverwriteMode: string): void {
        this.showOverwrite = false;
        this.currentOverwriteMethod = OverwriteMode;
        this.uploadFiles( this.currentProcessIndex).then( (processResult) => {
            if (processResult)
            {
                this.dialogRef.close(true);
            }
        });
    }

    confirmSave(): void {
        this.showConfirm = false;
        this.uploadFiles(0).then((processResult) => {
                if (processResult) {
                    this.dialogRef.close(true);
                }
            }
        );
    }
}

export class SaveFileModel {
    constructor(
        public fileList: any[] = [],
        public folderPath= '',
        public mustConfirm= false,
        public overwriteByDefault = false,
    )
    {

    }
}


